<!-- 产品线管理 ProductLine-->
<template>
  <div class="ProductLine">
    <div class="form_header">
      <el-form ref="form" :model="userform" label-width="100px">
        <div class="form_list">
          <el-form-item label="产品名称：">
            <el-input v-model="userform.name"></el-input>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="cancelbtn">取消</el-button>
          </div>
        </div>
      </el-form>
      <div class="dao_btn">
        <!-- <el-button type="primary" icon="el-icon-upload2">导出</el-button> -->
        <el-button type="primary" icon="el-icon-tickets" @click="mode" style="margin-right: 10px;">下载模板</el-button>
        <el-upload class="upload-demo" action accept=".xlsx, .xls, .csv" :show-file-list="false" :http-request="handlePreview" :limit="1">
          <el-button type="primary" icon="el-icon-download">导入</el-button>
        </el-upload>
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="userList" style="width: 100%" :row-class-name="rowClassName" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="产品名称"></el-table-column>
        <el-table-column prop="integral_count" label="设备数量"></el-table-column>
        <el-table-column fixed="right" label="操作" width="200">
          <template slot-scope="scope">
            <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">复制</el-button> -->
            <el-button type="text" size="small" v-if="scope.row.index>0" @click="sort(scope.row,1)">上移</el-button>
            <el-button type="text" size="small" v-if="scope.row.index+1!==userList.length" @click="sort(scope.row,2)">下移</el-button>
            <el-button type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button @click="removesize(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="noform">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="产品名称" prop="name">
          <el-input v-model="Edform.name"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noform">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import {
  productslists,
  productsedit,
  productsdelete,
  productsadd,
  productseditSort
} from "../../api/system.js";
import { excelimport, productstemplate, getCurrencys } from "../../api/comm.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      userform: {
        name: ""
      },
      Edform: {
        name: ""
      },
      userList: [
        {
          name: "9f30002",
          num: "1000",
          name1: "启用"
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }]
      },
      editID: ""
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //产品线列表
    produdata() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        name: this.userform.name,
        currency_id:localStorage.getItem('countryId')
      };
      productslists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.userList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
    },
    //搜索
    onSubmit() {
      this.currentindex = 1;
      // console.log(this.userform);
      this.produdata();
    },
    //取消搜索
    cancelbtn() {
      this.currentindex = 1;
      this.userform.name = "";
      this.produdata();
    },
    //复制
    handleClick(e) {
      // console.log(e);
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      this.pop_up = true;
      // console.log(e);
      this.editID = e.id;
      this.Edform.name = e.name;
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);

      if (this.Edform.name !== "") {
        if (this.titleName == "编辑") {
          let data = {
            id: this.editID,
            name: this.Edform.name,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          // console.log(data);
          productsedit(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.currentindex = 1;
              this.Edform.name = "";
              this.produdata();
              this.$message({
                message: "修改成功",
                type: "success"
              });
            }
          });
        } else {
          let data = {
            name: this.Edform.name,
            currency_id:parseInt(localStorage.getItem('countryId'))
          };
          productsadd(data).then(res => {
            if (res.status_code == 200) {
              this.pop_up = false;
              this.currentindex = 1;
              this.Edform.name = "";
              this.produdata();
              this.$message({
                message: "添加成功",
                type: "success"
              });
            }
          });
        }
      } else {
        this.$message({
          message: "请输入产品线名称",
          type: "warning"
        });
      }
    },
    //关闭弹窗
    noform() {
      this.Edform.name = "";
      this.pop_up = false;
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
    },
    //确定删除  handleClick
    removesize(e) {
      // console.log(e);
      this.$confirm("此操作将删除该产品线, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let data = {
            id: e.id
          };
          productsdelete(data).then(res => {
            if (res.status_code == 200) {
              this.currentindex = 1;
              this.produdata();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消删除"
          // });
        });
    },
    //模板下载
    mode() {
      location.href= process.env.VUE_APP_BASE_API + '/template_file/chanpinxian_template.xls'
      // productstemplate().then(res => {
      //   const blob = new Blob([res]);
      //   const downloadElement = document.createElement("a");
      //   const href = window.URL.createObjectURL(blob); // 创建下载的链接
      //   downloadElement.href = href;
      //   downloadElement.download = "产品线模板.xlsx"; // 下载后文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 点击下载
      //   document.body.removeChild(downloadElement); // 下载完成移除元素
      //   window.URL.revokeObjectURL(href); // 释放掉blob对象
      // });
    },
    //导入--上传
    handlePreview(file) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      form.append("type", "category_products");
      form.append("currency_id",localStorage.getItem('countryId'))
      let data = {
        file: minfile
      };
      excelimport(form).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.produdata();
          this.$message({
            type: "success",
            message: "导入成功!"
          });
        }
      });
    },
    rowClassName({ row, rowIndex }) {
      //把每一行的索引放进row
      row.index = rowIndex;
    },
    //修改排序
    sort(e, i) {
      // console.log(e);
      // console.log(i);
      let data;
      if (i == 1) {
        //  减 上移
        data = {
          id1: e.id,
          id2: this.userList[e.index - 1].id
        };
      } else {
        // 加 下移
        data = {
          id1: e.id,
          id2: this.userList[e.index + 1].id
        };
      }
      // console.log(data);
      productseditSort(data).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.Edform.name = "";
          this.produdata();
          this.$message({
            message: "修改成功",
            type: "success"
          });
        }
      });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.produdata();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.ProductLine {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    .btn_box {
      margin-left: 20px;
    }
    .dao_btn {
      display: flex;
      .upload-demo {
        margin-right: 10px;
      }
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.ProductLine {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>